import SIGNATURE_TYPE from './signatureType.gql';
import SAVE_CCB_LOAN from './saveCcbLoan.gql';
import SAVE_LOAN_EVENT from './saveLoanEvent.gql';

export {
  SIGNATURE_TYPE,
  SAVE_CCB_LOAN,
  SAVE_LOAN_EVENT,
};
